import { createIntl, createIntlCache } from 'react-intl';
import { appStore }                    from 'stores/AppStore';

const cache = createIntlCache();

export const getIntl = () => {
  return createIntl({
    locale: appStore.locale,
    messages: appStore.messages,
  }, cache);
};